import { api_GET, api_POST, api_PUT } from "./_api.js";

const documento_api = {
    getList: (status) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Documentos/getlist/${status ? status : ""}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Documentos/getitem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (documento) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Documentos`, documento)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (documento) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Documentos`, documento)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default documento_api;
